import type { UploadFileApi, UploadFileStore } from "./UploadFileStore";
import { defaultMaxFileSizeInMB } from "@/components/chat/Chatbox/constants";
import { useUploaderAPI } from "@/components/ui/upload";
import { useCallbackRef } from "@radix-ui/react-use-callback-ref";
import { useCreation } from "ahooks";
import { atom, useAtomValue } from "jotai";
import { useMemo } from "react";
import { Observable } from "rxjs";

export function useInitUploadFileStore(uploadFileStore?: UploadFileStore) {
  const uploadFileUrl = useAtomValue(
    useMemo(() => {
      return atom((get) => {
        if (!uploadFileStore) {
          return;
        }
        return get(uploadFileStore.uploadFileUrl);
      });
    }, [uploadFileStore?.uploadFileUrl])
  );
  const { upload } = useUploaderAPI({
    action: uploadFileUrl ?? "",
    acceptTypes: ["any"],
    fileSizeLimitInMBs: defaultMaxFileSizeInMB,
  });

  const uploadFileApi = useCallbackRef<UploadFileApi>(
    (args: { file: File }) => {
      return new Observable((subscriber) => {
        const item = upload(args);

        void item.promise
          .then((res) => {
            subscriber.next({
              objectName: res.objectName,
            });
          })
          .catch((err: unknown) => {
            subscriber.error(err);
          });

        return () => {
          item.abort?.();
        };
      });
    }
  );

  useCreation(() => {
    uploadFileStore?.setUploadFileApi(uploadFileApi);
  }, [uploadFileStore]);
}
